import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../app.config';
import { map } from 'rxjs/operators'

@Injectable({
	providedIn: 'root'
})
export class LanguageService {

	public isLoaded: boolean = false;
	public onLanguageLoaded: EventEmitter<boolean> = new EventEmitter();

	private data: Object;

	constructor(private http: HttpClient) { }

	public setLanguage(language: string): void {
		localStorage.setItem('language', language);
		this.http.get('assets/language/' + language + '.json')
			.pipe(map(res => { return res; })
			).subscribe((res: any) => {
				this.isLoaded = true;
				this.data = res.dictionary;
				this.onLanguageLoaded.emit(true);
			});
		

	}

	public saveRemote(userId: string) {
		this.http.put(ConfigService.REST_SERVER + '/api/user', { _id: userId, idioma: this.currentLanguage })
			.pipe(map(response => { }));
	}
	public getTranslation(value: string): string {
		return this.data && this.data[value] ? this.data[value].default : '¿' + value + '?';
	}

	public get currentLanguage(): string {
		return localStorage.getItem('language');
	}
}
